module.exports = __webpack_public_path__ + "c_static/img/invite-friends_img_bg_default@2x.15cee6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/邀请好友/invite-friends_img_bg_default@2x.png
// module id = iCMS
// module chunks = 33